import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ConfigCrud, CrudComponent } from '../../../components/crud/crud.component';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { SeguimientoService } from 'src/app/services/seguimiento.service';
import { ChecklistTranChecklist, EstatusRubro, GlobalChecklistValidacion, Usuario } from 'src/app/types/Entitys';
import { RangoCalificacionChecklist, RubroMotivoRechazo, TranRevision, TranRubroMotivoRechazo } from 'src/app/types/type';
import { UsuariosService } from 'src/app/services/usuarios.service';
declare var $: any;

@Component({
  selector: 'app-checklist-validacion',
  templateUrl: './checklist-validacion.component.html',
  styleUrls: ['./checklist-validacion.component.css']
})
export class ChecklistValidacionComponent implements OnInit {
  @ViewChild(CrudComponent) crudComponent: CrudComponent;
  finalizar: boolean = false;
  idRevision: any;
  idEmpleadoSesion: number;
  db: EstacionesTVADB;
  subMenus: { active: boolean; child: boolean; label: string; class: string; }[];
  global: GlobalChecklistValidacion;
  rechazoRubro: any;
  listRechazos: any;
  checklist: ChecklistTranChecklist;
  listHistorico: any;
  IdRubroObservacion: any;
  txtObservaciones: string;
  configCrudAcciones: ConfigCrud;
  activateCrudAcciones: boolean;
  revision: TranRevision;
  rangosCalificacionChecklist: RangoCalificacionChecklist[];
  btnRubroRechazo: boolean = false;
  btnRefresh: boolean = false;

  constructor(
    private seguimService: SeguimientoService,
    private userService: UsuariosService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private parent: AppComponent
  ) {
    this.activateCrudAcciones = true;
    parent.moduleName = 'Seguimiento';
    this.db = new EstacionesTVADB();
    this.idRevision = parseInt(this.activatedRoute.snapshot.params.id);
    this.global = {
      idRevision: this.idRevision,
      userSesion: null,
      CatEstatusRubro: null
    }
    this.listHistorico = [];
    this.crudAcciones();
  }

  async ngOnInit() {
    this.loadSubMenu();
    this.global.userSesion = await this.userService.getUsuario();
    this.checklist = null
    this.seguimService
      .loadInitChecklistValidacion(this.idRevision)
      .subscribe(([rubros, checklist, revision, rangosChecklist]) => {
        if (rubros.Result.Exito) {
          this.global.CatEstatusRubro = rubros.Result.Data as EstatusRubro[];
          this.global.CatEstatusRubro.push({
            IdEtapa: 0,
            Color: 'black',
            Descripcion: 'N/A',
            IdEstatusRubro: 0
          });
        } else
          Utilerias.alertClient('', rubros.Result.Error, 1);

        if (checklist.Result.Exito) {
          this.checklist = checklist.Result.Data as ChecklistTranChecklist
        } else
          Utilerias.alertClient('', checklist.Result.Error, 1);

        if (revision.Result.Exito) {
          this.revision = revision.Result.Data as TranRevision
        } else
          Utilerias.alertClient('', revision.Result.Error, 1);

        if (rangosChecklist.Result.Exito) {
          this.rangosCalificacionChecklist = rangosChecklist.Result.Data as RangoCalificacionChecklist[]
        } else
          Utilerias.alertClient('', rangosChecklist.Result.Error, 1);

        this.btnRefresh = false;
      });
    $('#modalMotivo').on('hidden.bs.modal', function (e) {
      Utilerias.ClearFields('#motivoText');
    })

  }

  crudAcciones() {
    let crudHttpAcciones = new CrudHttp(this.http)
    crudHttpAcciones.methodGet = "GetTranAccionRubros";
    crudHttpAcciones.methodPost = "PostTranAccionRubro";
    crudHttpAcciones.methodPut = "PutTranAccionRubro";
    crudHttpAcciones.methodDelete = "DeleteTranAccionRubro";
    this.configCrudAcciones = {
      model: [{
        key: 'IdAccion',
        label: 'Folio'
      },
      {
        key: 'Descripcion',
        label: 'Descripción',
        isInput: true,
        isRequired: true,
        isTextArea: true
      }],
      collection: [],
      crudHttp: crudHttpAcciones,
      title: 'Listado de acciones del rubro',
      labelDelete: 'idAccion',
      primaryKey: 'IdAccion',
      itemEdit: {},
      crudId: 'Acciones'
    };
  }

  async Downloadinforme() {
    var file: any = await Utilerias.httpRequest(this.http, 'DownloadInformeFinal', 'post', { idRevision: this.idRevision });
    Utilerias.downloadFile(file.NombreArchivo, file.Contenido)
    Utilerias.showLoader(false);
  }

  async informeFinal() {
    var result = await Utilerias.alertConfirm('¿Esta seguro de cerrar la revisión? </br>Una vez cerrada ya no se podrá realizar ninguna operación.');
    if (result.value) {
      $('#modalConclusion').modal('hide');
      Utilerias.httpRequest(this.http, 'GetInformeFinalRevision', 'post', { idRevision: this.idRevision, preliminar: false })
        .then((res: any) => {
          this.revision.IdEtapa = 5;
          Utilerias.showLoader(false);
          Utilerias.downloadFile(res.Nombre, res.Contenido);

        });
    }
  }

  updateConclusion() {
    Utilerias.httpRequest(this.http, 'UpdateConclusionRevision', 'post', { idRevision: this.idRevision, conclusion: $('#txtConclusion').val() })
      .then((res: any) => {
        Utilerias.showLoader(false);
        this.informeFinal();
      }).catch(res => {
        Utilerias.alertClient('', 'El campo conclusión es requerido para poder generar el informe.', 1);
      })
  }

  async conclusion() {
    this.getConclusion();
    Utilerias.showLoader(false);
    $('#modalConclusion').modal('show');
  }

  informe() {
    $('#modalConclusionPreliminar').modal('hide');
    this.finalizar = true;
    Utilerias.httpRequest(this.http, 'GetInformeFinalRevision', 'post', { idRevision: this.idRevision, preliminar: true })
      .then((res: any) => {
        this.revision.IdEtapa = 4;
        Utilerias.showLoader(false);
        Utilerias.downloadFile(res.Nombre, res.Contenido);
      });
  }

  updateConclusionPreliminar() {
    Utilerias.httpRequest(this.http, 'UpdateConclusionRevision', 'post', { idRevision: this.idRevision, conclusion: $('#txtConclusionPreliminar').val() })
      .then((res: any) => {
        Utilerias.showLoader(false);
        this.informe();
      }).catch(res => {
        Utilerias.alertClient('', 'El campo conclusión es requerido para poder generar el informe.', 1);
      })
  }

  async conclusionPreliminar() {
    this.getConclusion();
    Utilerias.showLoader(false);
    $('#modalConclusionPreliminar').modal('show');
  }

  getConclusion() {
    Utilerias.httpRequest(this.http, 'GetConclusionRevision', 'post', { idRevision: this.idRevision })
      .then((res: any) => {
        $('#txtConclusionPreliminar').val(res.Conclusion);
        $('#txtConclusion').val(res.Conclusion);
      }).catch(res => {
        $('#txtConclusionPreliminar').val('');
        $('#txtConclusion').val('');
      });
  }

  refresh() {
    this.btnRefresh = true;
    this.ngOnInit();
  };

  replaceSaltoHTML(input: string) {
    return Utilerias.replaceSaltoHTML(input);
  }

  datetimeToDateFormat(input: string, withTime: boolean = false) {
    return Utilerias.datetimeToDateFormat(input, withTime);
  }

  getUserSesion() {
    return MasterDB.getUsuarioSesion(this.db);
  }

  bigEvidencia() {
    Utilerias.openImgNewWindow($('#imgEvidencia')[0].src);
  }

  isCumpleRubro(rubroCalificacion: number) {
    let rango = Utilerias.resultRangeChecklist(this.rangosCalificacionChecklist, rubroCalificacion)
    return [1].includes(rango.IdRango);
  }

  async terminarRevision() {
    this.finalizar = false;
    Utilerias.httpRequest(this.http, 'CerrarRevision', 'post', { idrevision: this.idRevision })
      .then((res: any) => {
        Utilerias.Loader(false);
        Utilerias.alertClient('', 'Se ha finalizado la revisión correctamente actualice la pantalla.', 1);
      }).catch(res => {
        Utilerias.Loader(false);
        Utilerias.alertClient('', 'Ha ocurrido un error en el proceso de finalizar la revisión.', 1);
      })
  }

  async frmPostRechazoRubro(e: Event) {    
    e.preventDefault();
    this.btnRubroRechazo = true;
    
    const IdRubro = parseInt(localStorage.getItem('IdRubroValidar'));

    const {
      IdEmpleado,
      Roles
    } = await MasterDB.getUsuarioSesion(this.db);

    let bodyRequest: RubroMotivoRechazo = {
      t: {
        IdRubro,
        IdRevision: this.idRevision,
        MotivoRechazo: $('#motivoText').val(),
        IdEmpleadoRechazo: IdEmpleado,
        IdRolEmpleadoRechazo: Roles[0].IdRol
      },
      historial: {
        IdRubro,
        IdRevision: this.idRevision,
        IdRolValido: Roles[0].IdRol,
        IdEmpleadoValido: IdEmpleado,
        FlagValidadoRechazado: 0
      }
    };

    this.seguimService.postRubroMotivoRechazo(bodyRequest)
      .subscribe(response => {
        if (response.Result.Exito) {
          const { IdRubro } = response.Result.Data as TranRubroMotivoRechazo          
          for (const bloque of this.checklist.Bloques) {            
            const rubro = bloque.Rubros.find(r => r.IdRubro === IdRubro);
            if (rubro) {
              rubro.IdEstatus = 4;
              break;
            }
          }
          localStorage.removeItem('IdRubroValidar');
          $('#modalMotivo').modal('hide');
        }
        this.btnRubroRechazo = false;
      });
  }

  frmPostObservacion(e: Event) {
    e.preventDefault();
    Utilerias.httpRequest(this.http, 'PostObservacionRubro', 'post', {
      tranRubro: {
        IdRubro: this.IdRubroObservacion,
        IdRevision: this.idRevision,
        ObservacionesInformeFinal: this.txtObservaciones,
      }
    })
      .then((res: any) => {
        let flag = false;
        for (let item of this.checklist.Bloques) {
          for (let rubro of item.Rubros) {
            if (flag = rubro.IdRubro == res.IdRubro) {
              rubro.ObservacionesInformeFinal = res.ObservacionesInformeFinal;
              break;
            }
          }
          if (flag) { break; }
        }
        this.txtObservaciones = '';
        $('#modalObservaciones').modal('hide');
      })
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Cartera de revisiones',
        class: 'submenu__item d-flex align-items-center',
        router: '../../',
      },
      {
        active: true,
        child: false,
        label: 'Checklist validación',
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}
